import { TranslationSet } from './en';

// TODO: translate values from English
export const es: TranslationSet = {
  '(From Now)': '(Desde ahora)',
  '(From Scheduled)': '(De lo programado)',
  '{amount} Off. Expires: {expires}.': '{amount} Desactivado. Vence: {expires}.',
  'A detailed report showing each activity and how long a technician or staff member took between and at each site with a total time at the site.': 'Un informe detallado que muestra cada actividad y cuánto tiempo tardó un técnico o miembro del personal entre y en cada sitio con un tiempo total en el sitio.',
  'A service type with inspection enabled will show up in the "to inspect" list on mobile. It is also used in reporting.': 'Un tipo de servicio con inspección habilitada aparecerá en la lista "para inspeccionar" en el móvil. También se utiliza en informes.',
  'Accept Invite': 'Aceptar invitación',
  'Add Condition': 'Agregar condición',
  'Add deficiencies to the equipment type': 'Agregar deficiencias al tipo de equipo.',
  'Add Deficiency': 'Agregar deficiencia',
  'Add Equipment Field': 'Agregar campo de equipo',
  'Add Equipment Type': 'Agregar tipo de equipo',
  'Add Equipment': 'Agregar equipo',
  'Add Floor Plan': 'Agregar plano de planta',
  'Add history by clicking the plus in the top right or by performing a service.': 'Agregue historial haciendo clic en el signo más en la parte superior derecha o realizando un servicio.',
  'Add History': 'Agregar historial',
  'Add Model Field': 'Agregar campo de modelo',
  'Add Model': 'Agregar modelo',
  'Add Option': 'Agregar opción',
  'Add Question': 'Agregar pregunta',
  'Add questions using the plus icon in the top right': 'Agregue preguntas usando el ícono más en la parte superior derecha',
  'Add service month categories in settings > service month categories. Service months allow you to keep different types of equipment in selected months for each location. Example: Alarms in May and October and Extinguishers in December.': 'Agregue categorías de mes de servicio en configuración> categorías de mes de servicio. Los meses de servicio le permiten mantener diferentes tipos de equipos en meses seleccionados para cada ubicación. Ejemplo: Alarmas en mayo y octubre y Extintores en diciembre.',
  'Add Service Month Category': 'Agregar categoría del mes de servicio',
  'Add Service Type': 'Agregar tipo de servicio',
  'Add service types in the settings': 'Agregar tipos de servicios en la configuración',
  'Add service types using the plus icon in the top right': 'Agregue tipos de servicios usando el ícono más en la parte superior derecha',
  'Add services to the equipment type': 'Agregar servicios al tipo de equipo',
  'Add site Field': 'Agregar campo de sitio',
  'Add Site Override': 'Agregar anulación de sitio',
  'Add Site Type': 'Agregar tipo de sitio',
  'Add Site': 'Agregar sitio',
  'Add Sites': 'Agregar sitios',
  'Add User': 'Agregar usuario',
  'Add your own fields in Settings > Custom Fields > Site Fields': 'Agregue sus propios campos en Configuración > Campos personalizados > Campos del sitio',
  'Add': 'Añadir',
  'Adding': 'Añadiendo',
  'Address': 'Dirección',
  'Advance from Now': 'Avanzar desde ahora',
  'Advance from Scheduled': 'Avance de lo programado',
  'Agree': 'De acuerdo',
  'All Sites Scheduled!': '¡Todos los sitios programados!',
  'All': 'Todos',
  'Already have an account? Login': '¿Ya tienes una cuenta? Iniciar sesión',
  'An error happened while syncing': 'Ocurrió un error al sincronizar',
  'April': 'abril',
  'August': 'agosto',
  'Back': 'Atrás',
  'Billing Portal': 'Portal de facturación',
  'Building Reports': 'Informes de construcción',
  'Cancel Plan': 'Cancelar plan',
  'Cancel Subscription': 'Cancelar suscripción',
  'Cancel': 'Cancelar',
  'Change Model Fields': 'Cambiar campos del modelo',
  'Change Password': 'Cambiar contraseña',
  'Checklist Information': 'Información de la lista de verificación',
  'Checklist Question': 'Pregunta de la lista de verificación',
  'Checklist': 'Lista de verificación',
  'Choose File': 'Elija archivo',
  'City': 'ciudad',
  'Clear All Data': 'Borrar todos los datos',
  'Clear': 'Borrar',
  'Click or tap to add location': 'Haga clic o toque para agregar ubicación',
  'Close': 'Cerrar',
  'Company-Wide Reports': 'Informes de toda la empresa',
  'Conditions': 'Condiciones',
  'Contact': 'Contacto',
  'Copy Barcode': 'Copiar código de barras',
  'Could not access': 'No se pudo acceder',
  'Could not find equipment with the scanned barcode': 'No se pudo encontrar el equipo con el código de barras escaneado',
  'Could Not Service': 'No se pudo dar servicio',
  'Create': 'crear',
  'Creating Your Account': 'Creando tu cuenta',
  'Credentials are not valid': 'Las credenciales no son válidas',
  'CSV': 'CSV',
  'Custom Equipment Fields': 'Campos de equipo personalizados',
  'Custom Fields': 'Campos personalizados',
  'Custom Model Fields': 'Campos de modelo personalizados',
  'Custom site Fields': 'Campos de sitio personalizados',
  'Date': 'Fecha',
  'Debug': 'Depurar',
  'December': 'diciembre',
  'Deficiencies': 'Deficiencias',
  'Deficiency Report': 'Informe de deficiencia',
  'Deficiency': 'deficiencia',
  'Delete Equipment Field?': '¿Eliminar campo de equipo?',
  'Delete Equipment Type?': '¿Eliminar tipo de equipo?',
  'Delete Equipment Type': 'Eliminar tipo de equipo',
  'Delete Equipment?': '¿Eliminar equipo?',
  'Delete Equipment': 'Eliminar equipo',
  'Delete Floor Plan?': '¿Eliminar plano de planta?',
  'Delete Model Field?': '¿Eliminar campo de modelo?',
  'Delete Model?': '¿Eliminar modelo?',
  'Delete Model': 'Eliminar modelo',
  'Delete Override': 'Eliminar anulación',
  'Delete Question?': '¿Eliminar pregunta?',
  'Delete Question': 'Eliminar pregunta',
  'Delete Record?': '¿Eliminar registro?',
  'Delete Service Month?': '¿Eliminar el mes de servicio?',
  'Delete Service Type?': '¿Eliminar tipo de servicio?',
  'Delete Site Field?': '¿Eliminar campo del sitio?',
  'Delete Site Type?': '¿Eliminar tipo de sitio?',
  'Delete Site?': '¿Eliminar sitio?',
  'Delete Site': 'Eliminar sitio',
  'Delete User?': '¿Eliminar usuario?',
  'Delete User': 'Eliminar usuario',
  'Delete': 'Eliminar',
  'Deleted Equipment Field': 'Campo de equipo eliminado',
  'Deleted Equipment': 'Equipo eliminado',
  'Deleted Floor Plan': 'Plano de planta eliminado',
  'Deleted Model Field': 'Campo de modelo eliminado',
  'Deleted Record': 'Registro eliminado',
  'Deleted Service Month': 'Mes de servicio eliminado',
  'Deleted Service Type': 'Tipo de servicio eliminado',
  'Deleted Site Field': 'Campo de sitio eliminado',
  'Deleted Site Type': 'Tipo de sitio eliminado',
  'Detailed': 'Detallado',
  'Did not want done': 'no queria hecho',
  'Done by others': 'Hecho por otros',
  'Don\'t have an account? Sign Up': '¿No tienes una cuenta? Regístrate',
  'Done': 'hecho',
  'Edit Dates': 'Editar fechas',
  'Edit Equipment': 'Editar equipo',
  'Edit': 'Editar',
  'Email is not valid': 'El correo electrónico no es válido.',
  'End Date': 'Fecha de finalización',
  'Enter your email address': 'Introduce tu dirección de correo electrónico',
  'Equipment already has this barcode': 'El equipo ya tiene este código de barras.',
  'Equipment can be anything from a fire extinguisher to a treadmill. Set up equipment types in settings > equipment types.': 'El equipo puede ser cualquier cosa, desde un extintor de incendios hasta una cinta de correr. Configure los tipos de equipos en configuración > tipos de equipos.',
  'Equipment Deleted': 'Equipo eliminado',
  'Equipment Due Consolidated Report': 'Informe consolidado de vencimiento de equipos',
  'Equipment Due Report': 'Informe de vencimiento del equipo',
  'Equipment Field Information': 'Información de campo del equipo',
  'Equipment fields allow you to add different additional fields on the equipment type, such as "Voltage" or "Km".': 'Los campos de equipo le permiten agregar diferentes campos adicionales sobre el tipo de equipo, como "Voltaje" o "Km".',
  'Equipment Fields': 'Campos de equipo',
  'Equipment for a site with all scheduled services.': 'Equipamiento para un sitio con todos los servicios programados.',
  'Equipment Options': 'Opciones de equipo',
  'Equipment Report': 'Informe del equipo',
  'Equipment Service Report': 'Informe de servicio del equipo',
  'Equipment SKU': 'SKU del equipo',
  'Equipment Type Deleted': 'Tipo de equipo eliminado',
  'Equipment Type': 'Tipo de equipo',
  'Equipment types quickly add inspection and service definitions to equipment when a model containing it is selected. Examples: Fire Extinguisher, Treadmill, Truck': 'Los tipos de equipos agregan rápidamente definiciones de inspección y servicio al equipo cuando se selecciona un modelo que los contiene. Ejemplos: extintor de incendios, cinta de correr, camión',
  'Equipment Types': 'Tipos de equipos',
  'Equipment': 'Equipo',
  'Export Billing Data': 'Exportar datos de facturación',
  'Export Data': 'Exportar datos',
  'Export': 'Exportar',
  'Failed to load organization.': 'No se pudo cargar la organización.',
  'Failed to save the organization.': 'No se pudo salvar la organización.',
  'February': 'febrero',
  'Fill out the options below to prepare your report.': 'Complete las opciones a continuación para preparar su informe.',
  'Filter By': 'Filtrar por',
  'FlameTask Basic Subscription': 'Suscripción básica a FlameTask',
  'FlameTask Enterprise Subscription': 'Suscripción empresarial FlameTask',
  'FlameTask Pro Subscription': 'Suscripción FlameTask Pro',
  'Floor Plan Location': 'Ubicación del plano de planta',
  'Floor Plan': 'Plano de planta',
  'Floor Plans': 'Planos de planta',
  'Force Error': 'Error de fuerza',
  'Forgot Password': 'Olvidé mi contraseña',
  'Generate': 'generar',
  'Hide "added" history records': 'Ocultar registros del historial "agregados"',
  'Hide Advanced': 'Ocultar Avanzado',
  'History': 'Historia',
  'How long a user spent at a site with time between actions.': 'Cuánto tiempo pasó un usuario en un sitio con tiempo entre acciones.',
  'If this email matched an account, a link was sent to reset your password.': 'Si este correo electrónico coincidía con una cuenta, se envió un enlace para restablecer su contraseña.',
  'Import Data': 'Importar datos',
  'Import': 'Importar',
  'Inspection Due': 'Inspección pendiente',
  'Inspection Report': 'Informe de inspección',
  'Inspection': 'Inspección',
  'Inspections are up to date': 'Las inspecciones están al día.',
  'January': 'enero',
  'July': 'julio',
  'June': 'junio',
  'Leave': 'salir',
  'List of all equipment at the site with options to show services and filtering based on due service and/or inspection.': 'Listado de todos los equipos en el sitio con opciones para mostrar servicios y filtrado en base al debido servicio y/o inspección.',
  'List of all sites with their information. Options to filter by status and service month to find which sites are serviced in a specific month.': 'Lista de todos los sitios con su información. Opciones para filtrar por estado y mes de servicio para encontrar qué sitios reciben servicio en un mes específico.',
  'List of equipment and deficiencies at the site, filtered by equipment with deficiencies that have a date opened and no closed date.': 'Listado de equipos y deficiencias en el sitio, filtrados por equipos con deficiencias que tienen fecha de apertura y sin fecha de cierre.',
  'List of equipment between a range of dates with answers to the questions asked when performing a service or inspection.': 'Listado de equipos entre un rango de fechas con respuestas a las preguntas realizadas al realizar un servicio o inspección.',
  'List of Equipment for a site with important information such as last inspection date and next due service, highlighting equipment due for inspection in red.': 'Lista de equipos para un sitio con información importante, como la fecha de la última inspección y el próximo servicio, resaltando en rojo los equipos que deben inspeccionarse.',
  'List of equipment that fits model search criteria. Example: a list of 5 pieces of equipment with model information matching 6LB ABC DRY.': 'Listado de equipos que se ajustan a criterios de búsqueda de modelos. Ejemplo: una lista de 5 equipos con información del modelo que coincide con 6LB ABC DRY.',
  'Loading Equipment': 'Equipo de carga',
  'Loading Models...': 'Cargando modelos...',
  'Loading Scheduled Services...': 'Cargando servicios programados...',
  'Loading Scheduled Sites': 'Cargando sitios programados',
  'Loading Service Types...': 'Cargando tipos de servicios...',
  'Loading Sites': 'Cargando sitios',
  'Loading Unscheduled Services...': 'Cargando servicios no programados...',
  'Loading...': 'Cargando...',
  'Location': 'Ubicación',
  'Logging in...': 'Iniciando sesión...',
  'Login Failed': 'Error al iniciar sesión',
  'Login': 'Iniciar sesión',
  'Logout': 'Cerrar sesión',
  'March': 'marzo',
  'May': 'mayo',
  'Meter Based Condition': 'Condición basada en el medidor',
  'Model Deleted': 'Modelo eliminado',
  'Model Field Information': 'Información del campo del modelo',
  'Model fields allow you to describe and report on equipment such as "Size", "Type" and "Category".': 'Los campos del modelo le permiten describir e informar sobre equipos como "Tamaño", "Tipo" y "Categoría".',
  'Model Fields': 'Campos modelo',
  'Model Information': 'Información del modelo',
  'Model Name': 'Nombre del modelo',
  'Models allow quickly adding information to equipment such as which equipment type/services belong to it.': 'Los modelos permiten agregar rápidamente información a los equipos, como qué tipo de equipo/servicios le pertenecen.',
  'Models': 'Modelos',
  'Months of History (to start of month)': 'Meses de Historia (hasta inicio de mes)',
  'More Details': 'Más detalles',
  'Name': 'Nombre',
  'Nevermind': 'No importa',
  'No Custom Equipment Fields': 'Sin campos de equipo personalizados',
  'No Deficiencies': 'Sin deficiencias',
  'No Equipment Fields': 'Sin campos de equipo',
  'No Equipment Types': 'Sin tipos de equipos',
  'No Equipment': 'Sin equipo',
  'No Floor Plans': 'Sin planos de planta',
  'No History': 'Sin historia',
  'No Model Fields': 'Sin campos de modelo',
  'No Models': 'Sin modelos',
  'No Open Deficiencies': 'Sin deficiencias abiertas',
  'No Open or Closed Issues': 'No hay problemas abiertos ni cerrados',
  'No overrides for this Site': 'No hay anulaciones para este sitio',
  'No Questions': 'Sin preguntas',
  'No Scheduled Services': 'Sin servicios programados',
  'No Scheduled Sites': 'No hay sitios programados',
  'No Service Month Categories': 'Categorías del mes sin servicio',
  'No Service Types': 'Sin tipos de servicios',
  'No Site Fields': 'Sin campos de sitio',
  'No Site Types': 'Sin tipos de sitios',
  'No Sites': 'Sin sitios',
  'No Unscheduled Services': 'Sin servicios no programados',
  'No, Go Back': 'No, volver',
  'No': 'No',
  'Not in at the time of inspection': 'No estaba en el momento de la inspección.',
  'Nothing to Inspect': 'Nada que inspeccionar',
  'Nothing to Service': 'Nada que servir',
  'November': 'noviembre',
  'October': 'octubre',
  'Ok': 'Ok',
  'Open a deficiency by clicking the plus in the top right of the pane. When the issue has been resolved, click on it and set the closed date.': 'Abra una deficiencia haciendo clic en el signo más en la parte superior derecha del panel. Cuando se haya resuelto el problema, haga clic en él y establezca la fecha de cierre.',
  'Open a deficiency by tapping Options > Add Deficiency': 'Abra una deficiencia tocando Opciones > Agregar deficiencia',
  'Open Deficiencies': 'Deficiencias abiertas',
  'Open Deficiency': 'Deficiencia Abierta',
  'Open in Apple Maps': 'Abrir en Apple Maps',
  'Open in Google Maps': 'Abrir en Google Maps',
  'Open Settings': 'Abrir configuración',
  'Open': 'Abierto',
  'Optional: Add a deficiency if this option is selected.': 'Opcional: agregue una deficiencia si se selecciona esta opción.',
  'Optional: This can be useful to set meter values easily': 'Opcional: esto puede resultar útil para configurar los valores del medidor fácilmente',
  'Organization': 'Organización',
  'Outstanding Equipment': 'Equipo excepcional',
  'PDF': 'PDF',
  'Perform From Now': 'Realizar desde ahora',
  'Perform From Scheduled': 'Realizar desde lo programado',
  'Perform Service From Scheduled': 'Realizar el servicio programado',
  'Perform Service': 'Realizar servicio',
  'Perform': 'Realizar',
  'Phone Number': 'Número de teléfono',
  'Please fill out all fields': 'Por favor complete todos los campos',
  'Please give a reason': 'Por favor da una razón',
  'Please select country first': 'Por favor seleccione el país primero',
  'Popup Note': 'Nota emergente',
  'Preferences': 'Preferencias',
  'Preview Details': 'Vista previa de detalles',
  'Profile': 'Perfil',
  'Purchase Barcodes': 'Comprar códigos de barras',
  'Question Deleted': 'Pregunta eliminada',
  'Question Information': 'Información de la pregunta',
  'Questionnaire Report': 'Informe del cuestionario',
  'Questions': 'Preguntas',
  'Range End': 'Fin de rango',
  'Range Start': 'Inicio de rango',
  'Reactivate': 'Reactivar',
  'Remove': 'Quitar',
  'Replace Barcode': 'Reemplazar código de barras',
  'Replace Equipment': 'Reemplazar equipo',
  'Replaced equipment': 'Equipo reemplazado',
  'Report Date': 'Fecha del informe',
  'Reports': 'Informes',
  'Save time and minimize risk by plotting the location of equipment on a floor plan of this site': 'Ahorre tiempo y minimice el riesgo trazando la ubicación del equipo en un plano de este sitio',
  'Save': 'Guardar',
  'Saving': 'Ahorro',
  'Scan barcode to make changes': 'Escanear código de barras para realizar cambios',
  'Scan Barcode': 'Escanear código de barras',
  'Scan': 'Escanear',
  'Schedule': 'Horario',
  'Scheduled Event': 'Evento programado',
  'Scheduled service definitions can be added to the equipment type in settings > equipment types': 'Las definiciones de servicios programados se pueden agregar al tipo de equipo en configuración > tipos de equipo',
  'Scheduled': 'Programado',
  'See More': 'Ver más',
  'Selecting an option will add a history record and remove it from the todo list': 'Al seleccionar una opción, se agregará un registro del historial y se eliminará de la lista de tareas pendientes.',
  'Selective Equipment Report': 'Informe de equipo selectivo',
  'September': 'septiembre',
  'Service Due': 'Servicio vencido',
  'Service month categories allow you to keep different types of equipment in different months. For example, you could inspect fire extinguishers in August and May and alarms in October.': 'Las categorías de meses de servicio le permiten conservar diferentes tipos de equipos en diferentes meses. Por ejemplo, podrías inspeccionar los extintores en agosto y mayo y las alarmas en octubre.',
  'Service Month Categories': 'Categorías del mes de servicio',
  'Service Month Category': 'Categoría del mes de servicio',
  'Service Month': 'Mes de Servicio',
  'Service months allow you to keep different types of equipment in selected months for each site. Example: Alarms in May and October and Extinguishers in December.': 'Los meses de servicio le permiten mantener diferentes tipos de equipos en meses seleccionados para cada sitio. Ejemplo: Alarmas en mayo y octubre y Extintores en diciembre.',
  'Service Months': 'Meses de servicio',
  'Service overrides allow you to disable a service or change the frequency for a specific site': 'Las anulaciones de servicios le permiten desactivar un servicio o cambiar la frecuencia de un sitio específico',
  'Service Type Settings': 'Configuración del tipo de servicio',
  'Service Type': 'Tipo de servicio',
  'Service Types': 'Tipos de servicio',
  'Service': 'Servicio',
  'Services are up to date': 'Los servicios están actualizados.',
  'Services': 'Servicios',
  'Set answer to equipment field': 'Establecer respuesta al campo de equipo',
  'Settings': 'Configuración',
  'Show Advanced': 'Mostrar avanzado',
  'Show History Time': 'Mostrar tiempo histórico',
  'Show Inspections': 'Mostrar inspecciones',
  'Show Questions / Answers': 'Mostrar preguntas/respuestas',
  'Show Services': 'Mostrar servicios',
  'Sign Up': 'Regístrate',
  'Simulate Scan': 'Simular escaneo',
  'Site Deleted': 'Sitio eliminado',
  'Site Field Information': 'Información del campo del sitio',
  'Site fields will allow you to enter additional information into the site, such as "Parking Location".': 'Los campos del sitio le permitirán ingresar información adicional en el sitio, como "Ubicación del estacionamiento".',
  'Site Fields': 'Campos del sitio',
  'Site Information': 'Información del sitio',
  'Site Report': 'Informe del sitio',
  'Site Reports': 'Informes del sitio',
  'Site Service Override': 'Anulación del servicio del sitio',
  'Site Service Overrides': 'Anulaciones de servicios del sitio',
  'Site Service Settings': 'Configuración del servicio del sitio',
  'Site Settings': 'Configuración del sitio',
  'Site Type': 'Tipo de sitio',
  'Site types allow you to change service types based on the site. For example, only monthly customers would show the monthly inspection.': 'Los tipos de sitio le permiten cambiar los tipos de servicios según el sitio. Por ejemplo, sólo los clientes mensuales mostrarían la inspección mensual.',
  'Site types allow you to have different service types at different types of sites. For example, you may have to do monthly inspections at one site and only an annual inspection at another.': 'Los tipos de sitio le permiten tener diferentes tipos de servicios en diferentes tipos de sitios. Por ejemplo, es posible que tenga que realizar inspecciones mensuales en un sitio y solo una inspección anual en otro.',
  'Site Types': 'Tipos de sitio',
  'Sites can help you organize equipment into places such as "Office" or "Warehouse". If you run a servicing company, you can add your clients as sites. ': 'Los sitios pueden ayudarle a organizar el equipo en lugares como "Oficina" o "Almacén". Si dirige una empresa de servicios, puede agregar a sus clientes como sitios. ',
  'Sites': 'Sitios',
  'Start Date': 'Fecha de inicio',
  'Start Trial': 'Iniciar prueba',
  'Status': 'Estado',
  'Summary of services at a site separated by model information. Example 5 Monthly Inspections with model information 6LB DRY ABC.': 'Resumen de servicios en un sitio separados por información del modelo. Ejemplo 5 Inspecciones mensuales con información del modelo 6LB DRY ABC.',
  'Swap Equipment': 'Intercambiar equipo',
  'Swapped equipment': 'Equipo intercambiado',
  'TEST': 'PRUEBA',
  'The EMS plan is a discounted plan for non-profit or publicly funded emergency services.  Please choose another plan if you do not match this criteria': 'El plan EMS es un plan con descuento para servicios de atención médica sin fines de lucro o financiados con fondos públicos.  Elija otro plan si no cumple con este criterio',
  'The popup note is used to remind you of important information regarding the location. It will appear when opening the location screen.': 'La nota emergente se utiliza para recordarle información importante sobre la ubicación. Aparecerá al abrir la pantalla de ubicación.',
  'There are no unscheduled sites with outstanding inspections, service or deficiencies.': 'No hay sitios no programados con inspecciones, servicios o deficiencias pendientes.',
  'There is no equipment at this site with this search criteria and due inspections': 'No hay equipos en este sitio con este criterio de búsqueda y debidas inspecciones.',
  'There is no equipment at this site with this search criteria and due service': 'No hay equipos en este sitio con este criterio de búsqueda y debido servicio.',
  'This Month': 'este mes',
  'Time at Site Detailed': 'Tiempo en el sitio detallado',
  'Time at Site': 'Tiempo en el sitio',
  'Time Based Condition': 'Condición basada en el tiempo',
  'Today': 'hoy',
  'Transfer Equipment': 'Equipo de transferencia',
  'Unscheduled service definitions can be added to the equipment type in settings > equipment types': 'Se pueden agregar definiciones de servicios no programados al tipo de equipo en configuración > tipos de equipo',
  'Unscheduled': 'no programado',
  'Updated barcode': 'Código de barras actualizado',
  'Used Equipment SKU': 'SKU de equipo usado',
  'Used for the billing export for new, swapped and replaced equipment.': 'Se utiliza para la facturación de exportación de equipos nuevos, permutados y reemplazados.',
  'User Deleted': 'Usuario eliminado',
  'User Information': 'Información del usuario',
  'User': 'Usuario',
  'Users': 'Usuarios',
  'View on FloorPlan': 'Ver en plano',
  'View Terms': 'Ver términos',
  'Whenever equipment is swapped the billing export will increment the quantitiy under this SKU.': 'Siempre que se cambie el equipo, la exportación de facturación incrementará la cantidad bajo este SKU.',
  'Yes, Delete Equipment Field': 'Sí, eliminar campo de equipo',
  'Yes, Delete Equipment Type': 'Sí, eliminar tipo de equipo',
  'Yes, Delete Equipment': 'Sí, eliminar equipo',
  'Yes, Delete Floor Plan': 'Sí, eliminar plano de planta',
  'Yes, Delete Model Field': 'Sí, eliminar el campo del modelo',
  'Yes, Delete Model': 'Sí, eliminar modelo',
  'Yes, Delete Question': 'Sí, eliminar pregunta',
  'Yes, Delete Record': 'Sí, eliminar registro',
  'Yes, Delete Service Month': 'Sí, eliminar el mes de servicio',
  'Yes, Delete Service Type': 'Sí, eliminar tipo de servicio',
  'Yes, Delete Site Field': 'Sí, eliminar el campo del sitio',
  'Yes, Delete Site Type': 'Sí, eliminar tipo de sitio',
  'Yes, Delete Site': 'Sí, eliminar sitio',
  'Yes, Delete User': 'Sí, eliminar usuario',
  'Zone': 'Zona',
  'Customer': 'Cliente',
  'Site': 'Sitio',
  'All Sites': 'Todos los sitios',
  'Loading Customers': 'Cargando clientes',
  'No Customers': 'Sin clientes',
  'Add Customer': 'Agregar cliente',
  'Customers are groups of sites with billing information.': 'Los clientes son grupos de sitios con información de facturación.',
  'Customers': 'Clientes',
  'Customer Information': 'Información del cliente',
  'Delete Customer': 'Eliminar cliente',
  'Yes, Delete Customer': 'Sí, eliminar cliente',
  'Delete Customer?': '¿Eliminar cliente?',
  'Customer Deleted': 'Cliente eliminado',
  'Create Customer': 'Crear cliente',
  'Assign Existing Customer': 'Asignar cliente existente',
  'Edit Customer': 'Editar cliente',
  'Enter a serial number': 'Introduzca un número de serie',
  'Remove Customer': 'Eliminar cliente',
  'Find': 'encontrar',
  'Sync Now': 'Sincronizar ahora',
  'Syncing...': 'Sincronizando...',
  'Find equipment by serial number': 'Buscar equipos por número de serie',
  'Last successful upload was {formattedDate}': 'La última carga exitosa fue {formattedDate}',
  'Up to date as of {formattedDate}': 'Actualizado a partir del {formattedDate}',
  'Zones are used to group locations in the location report': 'Las zonas se utilizan para agrupar ubicaciones en el informe de ubicación.',

  'Account Number': 'Número de cuenta',
  'Add Location Override': 'Agregar anulación de ubicación',
  'Add New Model': 'Agregar nuevo modelo',
  'Add Site Field': 'Agregar campo de sitio',
  'Address Line 2': 'Línea de dirección 2',
  'Agree to': 'Consentir en',
  'All conditions are true': 'Todas las condiciones son verdaderas.',
  'All Permissions': 'Todos los permisos',
  'Allow Text Input': 'Permitir entrada de texto',
  'An email with the reset password link below has been sent to': 'Se ha enviado un correo electrónico con el siguiente enlace para restablecer la contraseña a',
  'An error ocurred while trying to show this page.': 'Ocurrió un error al intentar mostrar esta página.',
  'Any condition is true': 'Cualquier condición es verdadera.',
  'Background Color': 'Color de fondo',
  'Billing and customer controls': 'Controles de facturación y clientes.',
  'Building Reports - Safety Scan': 'Informes de construcción: análisis de seguridad',
  'Change Another Service': 'Cambiar otro servicio',
  'Choose Site': 'Elija el sitio',
  'click here': 'haga clic aquí',
  'Closed Date': 'Fecha cerrada',
  'Closed Deficiencies': 'Deficiencias cerradas',
  'Company Information': 'Información de la empresa',
  'Company Name': 'nombre de empresa',
  'Completing Sign Up': 'Completando el registro',
  'Context ID': 'ID de contexto',
  'Could not find equipment with that barcode': 'No se pudo encontrar el equipo con ese código de barras',
  'Creating invite link...': 'Creando enlace de invitación...',
  'Current equipment failed to load': 'El equipo actual no pudo cargarse',
  'Data File': 'Archivo de datos',
  'Data Origin': 'Origen de los datos',
  'Date affected by': 'Fecha afectada por',
  'Date Completed': 'Fecha de finalización',
  'Date Started': 'Fecha de inicio',
  'Delete equipment?': '¿Eliminar equipo?',
  'Dev Environment': 'Entorno de desarrollo',
  'Disabled For': 'Deshabilitado para',
  'Disabled For Location': 'Deshabilitado por ubicación',
  'Do not change': 'no cambiar',
  'Due When': 'Vencimiento cuando',
  'Edit Deficiencies': 'Editar deficiencias',
  'Edit History': 'Editar historial',
  'Edit Location': 'Editar ubicación',
  'Edit Schedule': 'Editar horario',
  'Edit Service': 'Editar servicio',
  'Edit Settings': 'Editar configuración',
  'End Time': 'Hora de finalización',
  'Equal to': 'igual a',
  'Equipment Field': 'Campo de equipo',
  'Equipment replaced': 'Equipo reemplazado',
  'Equipment swapped': 'Equipo intercambiado',
  'Example: Broken Handle': 'Ejemplo: mango roto',
  'Frequency Type': 'Tipo de frecuencia',
  'Generate Reports': 'Generar informes',
  'Get started by checking out our tutorials on YouTube or setting up your account in settings.': 'Comience consultando nuestros tutoriales en YouTube o configurando su cuenta en la configuración.',
  'Global Search': 'Búsqueda global',
  'Greater than': 'Más que',
  'hasn&apos;t accepted their invite yet. You can': 'Aún no ha aceptado su invitación. ',
  'Include In Reports': 'Incluir en informes',
  'landscape LetterHead': 'paisaje membrete',
  'Last Date': 'Última fecha',
  'Last Date Minimum Granularity': 'Granularidad mínima de la última fecha',
  'Last Download': 'Última descarga',
  'Last Upload': 'Última carga',
  'Less than': 'Menos que',
  'Locations can only be added on a desktop browser': 'Las ubicaciones solo se pueden agregar en un navegador de escritorio',
  'Looks like you never finished signing up': 'Parece que nunca terminaste de registrarte',
  'Metered Condition': 'Condición medida',
  'Mobile Access': 'Acceso móvil',
  'Model Number': 'Número de modelo',
  'Next Date (Overide)': 'Próxima fecha (anular)',
  'No Conditions': 'Sin condiciones',
  'No Options': 'Sin opciones',
  'Not equal to': 'No igual a',
  'Opened Date': 'Fecha de apertura',
  'Option Selected': 'Opción seleccionada',
  'Perform On Scan': 'Realizar en escaneo',
  'Please click the button below to start your free 3 month trial': 'Haga clic en el botón a continuación para comenzar su prueba gratuita de 3 meses',
  'Please review the terms below': 'Por favor revise los términos a continuación',
  'Portrait LetterHead': 'Membrete vertical',
  'Postal Code': 'Código Postal',
  'Powered By': 'Desarrollado por',
  'Preventive Maintenance': 'Mantenimiento preventivo',
  'Profile Image': 'Imagen de perfil',
  'Receive marketing emails': 'Recibir correos electrónicos de marketing',
  'Rivison Inc.': 'Rivison Inc.',
  'Search Sites...': 'Buscar sitios...',
  'Search': 'Buscar',
  'Serial Number': 'Número de serie',
  'Service is Unscheduled': 'El servicio no está programado',
  'Service Options': 'Opciones de servicio',
  'Service or Inspection Due': 'Servicio o inspección pendiente',
  'Show All': 'Mostrar todo',
  'Show site selector in top corner': 'Mostrar selector de sitios en la esquina superior',
  'Sign-Up Failed. Ensure the email is not already is use.': 'Error de registro. ',
  'Sorry, an error occurred while trying to create an invite link. Please try again later, or reach out to support': 'Lo sentimos, se produjo un error al intentar crear un enlace de invitación. ',
  'Sorry, looks like you&apos;re offline. Please try again when you have an internet connection': 'Lo siento, parece que no estás conectado. ',
  'Start Time': 'Hora de inicio',
  'Successfully updated profile': 'Perfil actualizado exitosamente',
  'terms and conditions': 'Términos y condiciones',
  'Text Input': 'Entrada de texto',
  'The date below is used to show history records only.': 'La fecha a continuación se utiliza para mostrar registros históricos únicamente.',
  'This will just take a moment': 'Esto sólo tomará un momento',
  'Time Condition': 'Condición de tiempo',
  'Time Zone': 'Huso horario',
  'to generate another invite link.': 'para generar otro enlace de invitación.',
  'Toggle Flashlight': 'Alternar linterna',
  'Type more characters to narrow the search further': 'Escriba más caracteres para limitar aún más la búsqueda',
  'Use text answer for': 'Utilice la respuesta de texto para',
  'Version:': 'Versión:',
  'View Deficiencies': 'Ver deficiencias',
  'View Equipment': 'Ver Equipo',
  'View History': 'Ver historial',
  'View Location': 'Ver ubicación',
  'View Schedule': 'Ver horario',
  'View Service': 'Ver Servicio',
  'View Settings': 'Ver configuración',
  'We hope to see you again.': 'Esperamos verte de nuevo.',
  'Web Login': 'Iniciar sesión',
  'Welcome,': 'Bienvenido,',
  'White Label': 'Etiqueta Blanca',
  'Work Day End Time': 'Hora de finalización del día laboral',
  'Work Day Start Time': 'Hora de inicio del día laboral',
  'You must agree to the terms and conditions': 'Debes aceptar los términos y condiciones.',
  'Your Subscription Has Been Canceled': 'Su suscripción ha sido cancelada',
  '(Hidden)': '(Oculto)',
  'Action': 'Acción',
  'Address Two': 'Dirección 2',
  'Amount': 'Cantidad',
  'An email with the reset password link below has been sent to {email}': 'Se envió a {email} un correo electrónico con el enlace para restablecer la contraseña.',
  'Answer': 'Respuesta',
  'Barcode': 'Código de barras',
  'Billing': 'Facturación',
  'Care': 'Cuidado',
  'Cell': 'Celular',
  'Change': 'Cambiar',
  'Contact Information': 'Información de contacto',
  'Country': 'País',
  'Data': 'Datos',
  'Description': 'Descripción',
  'Details': 'Detalles',
  'Email': 'Correo electrónico',
  'Fax': 'Fax',
  'Floor': 'Piso',
  'Frequency': 'Frecuencia',
  'General': 'General',
  'Hour': 'Hora',
  'Layout': 'Diseño',
  'Leave page?': '¿Salir de la página?',
  'Logo': 'Logotipo',
  'Manufactured': 'Fabricado',
  'Minutes': 'Minutos',
  'Model': 'Modelo',
  'Never': 'Nunca',
  'Note': 'Nota',
  'Offline': 'Sin conexión',
  'Online': 'En línea',
  'Option': 'Opción',
  'Options': 'Opciones',
  'Other': 'Otro',
  'Password': 'Contraseña',
  'Permissions': 'Permisos',
  'Phone': 'Teléfono',
  'Plan': 'Plan',
  'Province': 'Provincia',
  'Question': 'Pregunta',
  'SKU': 'SKU',
  'Select a date range': 'Seleccione un rango de fechas',
  'Select a site to transfer this equipment to': 'Seleccione un sitio para transferir este equipo',
  'Select the application you are importing from below. If it is not listed, contact customer support and see if your data can be imported.': 'Seleccione a continuación la aplicación desde la que está importando. Si no aparece en la lista, comuníquese con soporte al cliente para ver si se pueden importar sus datos.',
  'Send me release notes, announcements, and other marketing emails': 'Enviarme notas de la versión, anuncios y otros correos electrónicos de marketing',
  'ServiceType': 'Tipo de servicio',
  'Setup': 'Configuración',
  'Site #': 'N.º de sitio',
  'Sites with no type': 'Sitios sin tipo',
  'State / Province': 'Estado / Provincia',
  'The mobile version of FlameTask will act close to the app, the desktop version is used for configuration.': 'La versión móvil de FlameTask se comportará de forma similar a la app; la versión de escritorio se usa para configuración.',
  'Type': 'Tipo',
  'When': 'Cuándo',
  'Your current changes will be discarded.': 'Se descartarán los cambios actuales.',
  'back': 'atrás',
};
